import React, { forwardRef } from 'react'

import { BasePressable } from './BasePressable'
import { StyledPressableContent } from './styled'
import { PressableProps } from './types'

export const Pressable = forwardRef(
  ({ children, withOpacity = true, ...props }: PressableProps, ref: any) => (
    <BasePressable {...props}>
      {({ pressed }) => (
        <StyledPressableContent
          ref={ref}
          behavior={withOpacity ? 'opacity' : undefined}
          pressed={pressed}
        >
          {children}
        </StyledPressableContent>
      )}
    </BasePressable>
  ),
)
